module.exports = __webpack_public_path__ + "img/winerackdog04.1b598f65.jpg";